const Video = () => {
    // Function to handle video play actions
    const playVideo = ($button) => {
        const $player = $button.next();
        const $image = $button.prev();
        const $parent = $button.parent();

        $player.addClass('is-active');
        $player[0].play(); // Play the video
        $image.addClass('hide');
        $button.addClass('hide');
        $parent.addClass('is-active');
    };

    // Function to open video popup and play the video
    const openVideoPopup = () => {
        const videooverlay = $('#video-popup');
        const video = $('#video-popup__iframe').get(0); // Get the video element

        videooverlay.fadeIn(100, () => {
            video.play(); // Play the video once popup fades in
        });
    };

    // Function to close video popup and stop the video
    const closeVideoPopup = () => {
        const videooverlay = $('#video-popup');
        const video = $('#video-popup__iframe').get(0); // Get the video element

        video.pause(); // Pause the video
        video.currentTime = 0; // Reset the video to the beginning

        videooverlay.fadeOut(100); // Fade out the popup
    };

    // Event listeners
    $(".js-play").on('click', function (e) {
        e.preventDefault();
        playVideo($(this)); // Call play video function with the button as a parameter
    });

    $(".js-video-btn").on('click', function (e) {
        e.preventDefault();
        openVideoPopup(); // Call open popup function
    });

    $("#video-popup__close").on('click', function () {
        closeVideoPopup(); // Call close popup function
    });

    // Select all video elements with class .js-video-fw
    const videos = document.querySelectorAll('.js-video-fw');
    
    function updateVideoSource() {
        videos.forEach((video) => {
            const desktopVideoSrc = video.getAttribute('data-video');
            const mobileVideoSrc = video.getAttribute('data-video-mobile');

            // Check the current window width and update source
            if (window.innerWidth <= 767) {
                // Use mobile video if width is 767px or smaller
                if (video.src !== mobileVideoSrc) {
                    video.pause();  // Pause before switching source
                    video.src = mobileVideoSrc;
                    video.load();  // Reload the video to apply the new source
                }
            } else {
                // Use desktop video if width is greater than 767px
                if (video.src !== desktopVideoSrc) {
                    video.pause();  // Pause before switching source
                    video.src = desktopVideoSrc;
                    video.load();
                }
            }
        });
    }

    // Run on initial load
    updateVideoSource();

    // Debounce resize event to avoid excessive firing
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(updateVideoSource, 150);
    });

    console.log('update 1');
};

export { Video };
